import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-terms-of-use-fwa',
    templateUrl: './terms-of-use-fwa.component.html',
    styleUrls: ['./terms-of-use-fwa.component.css'],
})
export class TermsOfUseFWAComponent implements OnInit {
    constructor(public dialogRef: MatDialogRef<TermsOfUseFWAComponent>) {}

    ngOnInit(): void {}

    close() {
        this.dialogRef.close();
    }
}
